
import { defineComponent, ref, onMounted, watch } from "vue"
import { Actions } from "@/store/enums/StoreEnums"
import { useStore } from "vuex"
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb"
import { ElMessage } from "element-plus"
import { CardDrawRecord } from "@/store/modules/CardDrawRecordModule"
import { CardSeriesOption } from "@/store/modules/CardSeriesModule"
import { CardPoolOption } from "@/store/modules/CardPoolModule"
import { CardRarityOption } from "@/store/modules/CardModule"
import StatisticsView from "./StatisticsView.vue"

export default defineComponent({
  components: {
    StatisticsView
  },
  setup() {
    onMounted(() => {
      setCurrentPageBreadcrumbs("抽卡记录", ["抽卡系统"])
      loadOptions()
    })

    const store = useStore()
    const tableData = ref<CardDrawRecord[]>([])
    const cardSeriesOptions = ref<CardSeriesOption[]>([])
    const cardPoolOptions = ref<CardPoolOption[]>([])
    const rarityOptions = ref<CardRarityOption[]>([])

    const formData = ref({
      user_keyword: '',
      card_series_id: '',
      card_pool_id: '',
      rarity: '',
      is_guaranteed: '',
      date_range: null as string[] | null
    })

    const page = ref({
      currentPage: 1,
      pageSize: 20,
      totalResult: 0,
    })

    // 统计相关
    const statisticsDialogVisible = ref(false)
    const statisticsFilters = ref({})

    const loadOptions = () => {
      store.dispatch(Actions.GET_ALL_CARD_SERIES).then(() => {
        cardSeriesOptions.value = store.getters.currentAllCardSeries
      })
      store.dispatch(Actions.GET_ALL_CARD_POOLS).then(() => {
        cardPoolOptions.value = store.getters.currentAllCardPools
      })
      store.dispatch(Actions.GET_CARD_RARITIES).then(() => {
        rarityOptions.value = store.getters.currentCardRarities
      })
    }

    // 当系列变化时，更新卡池选项
    watch(() => formData.value.card_series_id, (newVal) => {
      if (newVal) {
        store.dispatch(Actions.GET_ALL_CARD_POOLS, { card_series_id: newVal }).then(() => {
          cardPoolOptions.value = store.getters.currentAllCardPools
        })
      } else {
        store.dispatch(Actions.GET_ALL_CARD_POOLS).then(() => {
          cardPoolOptions.value = store.getters.currentAllCardPools
        })
      }
      formData.value.card_pool_id = ''
    })

    const buildQueryParams = () => {
      const params: Record<string, unknown> = {
        ...page.value
      }

      if (formData.value.user_keyword) {
        params.user_keyword = formData.value.user_keyword
      }
      if (formData.value.card_series_id) {
        params.card_series_id = formData.value.card_series_id
      }
      if (formData.value.card_pool_id) {
        params.card_pool_id = formData.value.card_pool_id
      }
      if (formData.value.rarity) {
        params.rarity = formData.value.rarity
      }
      if (formData.value.is_guaranteed) {
        params.is_guaranteed = formData.value.is_guaranteed
      }
      if (formData.value.date_range && formData.value.date_range.length === 2) {
        params.start_date = formData.value.date_range[0]
        params.end_date = formData.value.date_range[1]
      }

      return params
    }

    const query = () => {
      const params = buildQueryParams()

      store
        .dispatch(Actions.GET_CARD_DRAW_RECORDS, params)
        .then(() => {
          tableData.value = store.getters.currentCardDrawRecordsList
          page.value.totalResult = store.getters.currentCardDrawRecordsCount
        })
        .catch(() => {
          ElMessage.error('获取抽卡记录失败')
        })
    }

    query()

    const submitEvent = () => {
      page.value.currentPage = 1
      query()
    }

    const onPageChange = (e: { currentPage: number; pageSize: number }) => {
      page.value.currentPage = e.currentPage
      page.value.pageSize = e.pageSize
      query()
    }

    const onReset = () => {
      formData.value = {
        user_keyword: '',
        card_series_id: '',
        card_pool_id: '',
        rarity: '',
        is_guaranteed: '',
        date_range: null
      }
      page.value.currentPage = 1
      query()
    }

    const getRarityTagType = (rarity?: string) => {
      const typeMap: Record<string, string> = {
        'R': 'info',
        'SR': '',
        'SSR': 'success',
        'SSSR': 'warning',
        'UR': 'danger',
        'SAR': 'danger'
      }
      return typeMap[rarity || ''] || ''
    }

    const onViewStatistics = () => {
      statisticsFilters.value = buildQueryParams()
      statisticsDialogVisible.value = true
    }

    return {
      tableData,
      formData,
      cardSeriesOptions,
      cardPoolOptions,
      rarityOptions,
      submitEvent,
      page,
      onPageChange,
      onReset,
      getRarityTagType,
      onViewStatistics,
      statisticsDialogVisible,
      statisticsFilters
    }
  },
})
